import { render, staticRenderFns } from "./orderResult.vue?vue&type=template&id=64b3b30d&scoped=true"
import script from "./orderResult.vue?vue&type=script&lang=js"
export * from "./orderResult.vue?vue&type=script&lang=js"
import style0 from "./orderResult.vue?vue&type=style&index=0&id=64b3b30d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b3b30d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64b3b30d')) {
      api.createRecord('64b3b30d', component.options)
    } else {
      api.reload('64b3b30d', component.options)
    }
    module.hot.accept("./orderResult.vue?vue&type=template&id=64b3b30d&scoped=true", function () {
      api.rerender('64b3b30d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/orderResult.vue"
export default component.exports